import { Typography } from '@mui/material'

import { styles } from '../InfoPopper.styles'

type BulletItem = {
	details: string
	linkText?: string
	linkUrl?: string
	subItems?: {
		details: string
		linkText?: string
		linkUrl?: string
	}[]
	title?: string
}

type Props = {
	bulletItems: BulletItem[]
	bulletTitle?: string
}

export default function BulletedList({ bulletItems, bulletTitle }: Props) {
	return (
		<Typography component="div">
			{bulletTitle && (
				<Typography variant="body1" sx={styles.bulletTitle}>
					{bulletTitle}
				</Typography>
			)}
			<Typography sx={styles.popperFont}>
				<ul style={styles.bulletList}>
					{bulletItems.map((item, index) => (
						<li key={index}>
							{item.title && (
								<>
									<b>{item.title}</b>:{' '}
								</>
							)}
							{item.linkText && item.linkUrl ? (
								<>
									<a
										href={item.linkUrl}
										target="_blank"
										rel="noreferrer"
										style={styles.bulletLink}
									>
										{item.linkText}
									</a>
									{item.details}
								</>
							) : (
								item.details
							)}
							{item.subItems && item.subItems.length > 0 && (
								<ul style={styles.subBulletList}>
									{item.subItems.map((subItem, subIndex) => (
										<li key={`${index}-${subIndex}`}>
											{subItem.linkText &&
											subItem.linkUrl ? (
												<>
													<a
														href={subItem.linkUrl}
														target="_blank"
														rel="noreferrer"
														style={
															styles.bulletLink
														}
													>
														{subItem.linkText}
													</a>
													{subItem.details}
												</>
											) : (
												subItem.details
											)}
										</li>
									))}
								</ul>
							)}
						</li>
					))}
				</ul>
			</Typography>
		</Typography>
	)
}
